/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useCallback, useEffect, useState } from "react";

export function lockBodyScroll(): void {
  const body = document?.body;
  if (body) {
    body.style.overflowY = "hidden";
    body.style.overflowX = "hidden";
  }
}

export function unlockBodyScroll(): void {
  const body = document?.body;
  if (body) {
    body.style.overflowY = "auto";
    body.style.overflowX = "hidden";
  }
}

export const NavigationContext = createContext({
  isNavigationOpen: false,
  toggleNavigation: () => {},
  closeNavigation: () => {},
});

interface Props {
  children: React.ReactElement;
}

export const NavigationContextProvider: React.FC<Props> = ({ children }) => {
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  const toggleNavigation = useCallback(() => {
    setIsNavigationOpen((isNavigationOpen) => !isNavigationOpen);
  }, []);
  const closeNavigation = useCallback(() => setIsNavigationOpen(false), []);

  useEffect(() => {
    isNavigationOpen ? lockBodyScroll() : unlockBodyScroll();
  }, [isNavigationOpen]);

  return (
    <NavigationContext.Provider
      value={{
        isNavigationOpen,
        toggleNavigation,
        closeNavigation,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
